export const WORK_DAYS = 22;
export const SCENARIOS = { 'Small improvement': 10, 'Moderate improvement': 20, 'Strong improvement': 30 };
export const FIELDS = [
  { key: 'monthlyRos', label: 'Monthly repair orders', defaultValue: 900, min: 0, max: 10000, step: 1 },
  { key: 'advisors', label: 'Service advisors', defaultValue: 6, min: 0, max: 100, step: 1 },
  { key: 'technicians', label: 'Technicians', defaultValue: 18, min: 0, max: 200, step: 1 },
  { key: 'averageLaborHoursPerRo', label: 'Average labor hours per RO', defaultValue: 2, min: 0.5, max: 24, step: 0.1 },
  { key: 'averageGrossProfitPerRo', label: 'Average gross profit per RO ($)', defaultValue: 300, min: 0, max: 5000, step: 1 },
  { key: 'statusCallsPerDay', label: 'Inbound status-update calls per day', defaultValue: 20, min: 0, max: 500, step: 1 },
  { key: 'advisorMinutesLostPerDay', label: 'Advisor minutes per day spent chasing status / coordinating handoffs', note: 'Minutes per advisor', defaultValue: 45, min: 0, max: 240, step: 1 },
  { key: 'shopCoordinationMinutesPerDay', label: 'Technician / shop coordination minutes lost per day', note: 'Minutes per technician', defaultValue: 15, min: 0, max: 240, step: 1 },
  { key: 'overdueStalledPerDay', label: 'Overdue or stalled ROs requiring manual follow-up per day', defaultValue: 8, min: 0, max: 500, step: 1 },
];
export const DEFAULT_INPUTS = Object.fromEntries(FIELDS.map(f => [f.key, f.defaultValue]));

export function fieldError(field, value) {
  const number = Number(value);
  if (value == null || String(value).trim() === '' || !Number.isFinite(number) || number < field.min || number > field.max) {
    return `Enter a number from ${field.min} to ${field.max.toLocaleString('en-US')}.`;
  }
  if (Math.abs(number / field.step - Math.round(number / field.step)) > 0.000001) {
    return field.step === 1 ? 'Enter a whole number.' : 'Use increments of 0.1 hours.';
  }
  return '';
}

export function calculateOpportunity(inputs, recoveryPercent) {
  if (FIELDS.some(f => fieldError(f, inputs[f.key])) ||
      !Number.isFinite(Number(recoveryPercent)) || recoveryPercent === '' ||
      Number(recoveryPercent) < 0 || Number(recoveryPercent) > 100) return null;
  const recoveryRate = Number(recoveryPercent) / 100;
  const advisorHoursRecovered = inputs.advisors * inputs.advisorMinutesLostPerDay * WORK_DAYS * recoveryRate / 60;
  const shopHoursRecovered = inputs.technicians * inputs.shopCoordinationMinutesPerDay * WORK_DAYS * recoveryRate / 60;
  const teamHoursRecovered = advisorHoursRecovered + shopHoursRecovered;
  const statusCallsPotentiallyAvoided = inputs.statusCallsPerDay * WORK_DAYS * recoveryRate;
  const attentionItemsPotentiallyImproved = inputs.overdueStalledPerDay * WORK_DAYS * recoveryRate;
  const additionalRoEquivalentCapacity = shopHoursRecovered / inputs.averageLaborHoursPerRo;
  const equivalentCapacityPercent = inputs.monthlyRos > 0
    ? (additionalRoEquivalentCapacity / inputs.monthlyRos) * 100
    : null;
  const potentialMonthlyGrossProfitCapacity = additionalRoEquivalentCapacity * inputs.averageGrossProfitPerRo;
  return { advisorHoursRecovered, shopHoursRecovered, teamHoursRecovered, statusCallsPotentiallyAvoided,
    attentionItemsPotentiallyImproved, additionalRoEquivalentCapacity, equivalentCapacityPercent,
    potentialMonthlyGrossProfitCapacity, potentialAnnualGrossProfitCapacity: potentialMonthlyGrossProfitCapacity * 12 };
}

export const formatHours = value => value.toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
export const formatCount = value => value.toLocaleString('en-US', { maximumFractionDigits: 0 });
export const formatCurrency = value => value.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
